import * as React from "react"
const WhatsappLogoMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#4F2E03"
      d="M7.195.689a7.308 7.308 0 0 1 7.356 6.277 7.316 7.316 0 0 1-5.305 8.087 7.305 7.305 0 0 1-4.974-.406l-3.61.644a.563.563 0 0 1-.615-.778l1.114-2.568a7.315 7.315 0 0 1 1.23-9.349A7.308 7.308 0 0 1 7.195.689Zm.018 1.125a6.183 6.183 0 0 0-6.046 5.513 6.19 6.19 0 0 0 1.092 4.237c.113.16.134.367.056.547L1.495 14l2.754-.49a.563.563 0 0 1 .346.049 6.183 6.183 0 0 0 8.843-6.433 6.189 6.189 0 0 0-6.225-5.311Zm-.84 4.673a.938.938 0 0 1-.625.883 3.188 3.188 0 0 0 2.178 2.18c.047-.13.12-.25.22-.35l.069-.063a.937.937 0 0 1 .594-.212h.75c.217 0 .427.075.594.212l.069.063.062.069a.937.937 0 0 1-.726 1.531h-.75l-.213-.006a4.31 4.31 0 0 1-4.097-4.307v-.75a.938.938 0 0 1 .937-.937l.093.005c.184.018.358.09.501.207l.07.062.061.07a.937.937 0 0 1 .212.593v.75Z"
    />
  </svg>
)
export default WhatsappLogoMoblie
